<span style="width: 100%" class="scrollable-search-field-container">
  @if (!inputVal) {
    <ng-select
      style="width: 100%"
      [items]="filteredResult"
      [bindLabel]="labelKey"
      [placeholder]="searchPlaceHolder"
      [loading]="isLoading"
      loadingText="Loading..."
      [typeahead]="typeahead$"
      [clearable]="false"
      [appendTo]="appendTo"
      [formControl]="ctrl"
      (change)="onChange($event)"
      (scrollToEnd)="fetchData()"
      (blur)="selectSearchCtrl.markAsTouched()"
      >
      <ng-template ng-notfound-tmp>
        @if (!addNewOnNoEntriesFound) {
          <div class="ng-option disabled">
            {{ messageNoEntriesFound }}
          </div>
        }
        @if (addNewOnNoEntriesFound) {
          <div class="ng-option">
            <div class="add_customer_btn" (click)="createRecord()">
              <img
                src="../../../../../assets/img/add_customer_icon.svg"
                alt=""
                class="icon"
                width="20"
                height="20"
                />
              {{ addButtonLabel }}
            </div>
          </div>
        }
      </ng-template>
    </ng-select>
  }

  @if (inputVal) {
    <div class="form-row">
      <div class="form-group col-12">
        <div class="input-group">
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            [(ngModel)]="inputVal"
            />
          @if (!disabled) {
            <div class="clear-icon">
              <i class="fa fa-times" (click)="clearInput()"></i>
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (hasError()) {
    <div class="ssf-error">
      <small class="text-danger"> This field is required </small>
    </div>
  }
</span>
